<script>
export default {
  name: 'ShipmentStatusBadge',
  props: {
    status: { type: String, required: true },
  },
  computed: {
    t() {
      return this.$ecTranslate || ((k) => k)
    },
    statusLabel() {
      return this.t(`ELIXIO_CONNECT.SHIPMENT_STATUS_${this.status}`)
    },
    statusClass() {
      const map = {
        DRAFT: 'draft',
        ESTIMATED: 'estimated',
        CREATED: 'created',
        PICKUP_CREATED: 'pickup',
        IN_TRANSIT: 'transit',
        DELIVERED: 'delivered',
        CANCELLED: 'cancelled',
      }
      return map[this.status] ?? 'draft'
    },
  },
}
</script>

<template>
  <span class="ec-shipment-pill" :class="`ec-shipment-pill--${statusClass}`">
    {{ statusLabel }}
  </span>
</template>

<style scoped>
.ec-shipment-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.25em 0.85em;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.4;
  white-space: nowrap;
  border-radius: 50rem;
  border: 1px solid;
}

.ec-shipment-pill--draft {
  color: #6b7280;
  background-color: #f3f4f6;
  border-color: #d1d5db;
}

.ec-shipment-pill--estimated {
  color: #2563eb;
  background-color: #eff6ff;
  border-color: #93c5fd;
}

.ec-shipment-pill--created {
  color: #7c3aed;
  background-color: #f5f3ff;
  border-color: #c4b5fd;
}

.ec-shipment-pill--pickup {
  color: #16a34a;
  background-color: #f0fdf4;
  border-color: #86efac;
}

.ec-shipment-pill--transit {
  color: #d97706;
  background-color: #fffbeb;
  border-color: #fcd34d;
}

.ec-shipment-pill--delivered {
  color: #059669;
  background-color: #ecfdf5;
  border-color: #6ee7b7;
}

.ec-shipment-pill--cancelled {
  color: #dc2626;
  background-color: #fef2f2;
  border-color: #fca5a5;
}
</style>
